import React from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Table from '../../../../../facturotopia/table/Table';

const DetallesDelServicioList = (props) => {
  const handleEdit = (item) => {
    handleDelete(item);

    props.onEdit(item);
  };

  const handleDelete = (item) => {
    const newData = props.data.filter((value) => {
      return value.id !== item.id;
    });

    props.onChange(newData);
  };

  const { data = [] } = props;

  return (
    <Table
      columns={columns(handleEdit, handleDelete, props.editing)}
      rowKey={'id'}
      data={data}
    ></Table>
  );
};

const columns = (handleEdit, handleDelete, editing) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            disabled={!!editing}
            onClick={handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={['far', 'edit']} />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={['fas', 'trash']} />
          </Button>
        </>
      );
    },
  },
  {
    key: 'FormaPagoServ',
    title: 'Forma pago servicio',
    dataIndex: 'FormaPagoServ',
  },
  {
    key: 'TipoDeServ',
    title: 'Tipo de Servicio',
    dataIndex: 'TipoDeServ',
  },
  {
    key: 'RFCTerceroAutorizado',
    title: 'RFC tercero autorizado',
    dataIndex: 'RFCTerceroAutorizado',
  },
  {
    key: 'FechaServ',
    title: 'Fecha Servicio',
    dataIndex: 'FechaServ',
    render: (item) => {
      return <>{moment(item.FechaServ).format('YYYY-MM-DD')}</>;
    },
  },
  {
    key: 'PrecioServSinIVA',
    title: 'Precio servicio sin iva',
    dataIndex: 'PrecioServSinIVA',
  },
];

export default DetallesDelServicioList;
